import { __assign, __values } from 'tslib';
import get from 'lodash.get';

/**
 * getVariants
 *
 * returns an array of CSSObjects which make up a collection of variant styles from
 * a top-level theme object.
 *
 * The first object is the base style for the theme object and is followed by one
 * object per variant specified.
 *
 * @param theme - a complete theme object
 * @param themeKey - a top-level key of the theme
 * @param variants - an object specifying the variant for each variant type
 * @param variantKeys - an array specifying the order the variant style objects should be returned in
 */
function getVariants(theme, themeKey, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
variantProps, variantKeys) {
    var e_1, _a;
    if (!themeKey)
        return [];
    var componentTheme = get(theme, "components.".concat(themeKey));
    if (!componentTheme)
        return [];
    var themeVariants = componentTheme.variants, defaultProps = componentTheme.defaultProps, base = componentTheme.base, variantOrder = componentTheme.variantOrder;
    var result = [base];
    // theme variantOrder has higher priority than variantKeys argument
    var keys = variantOrder ||
        variantKeys ||
        Object.keys(__assign(__assign({}, defaultProps), themeVariants));
    try {
        for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
            var varKey = keys_1_1.value;
            var varSet = themeVariants[varKey];
            if (varSet) {
                var variantProp = variantProps === null || variantProps === void 0 ? void 0 : variantProps[varKey];
                var varOption = variantProp !== undefined ? variantProp : defaultProps === null || defaultProps === void 0 ? void 0 : defaultProps[varKey];
                if (varOption !== undefined) {
                    result.push(varSet["".concat(varOption)]);
                }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return result;
}

export { getVariants };
//# sourceMappingURL=getVariants.js.map
